import { render, staticRenderFns } from "./AddSubAccount.vue?vue&type=template&id=f2af8994&"
import script from "./AddSubAccount.vue?vue&type=script&lang=js&"
export * from "./AddSubAccount.vue?vue&type=script&lang=js&"
import style0 from "./AddSubAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports